import { Select, type SelectProps } from "antd";
import { useMemo } from "react";
import { useIntl } from "react-intl";
import { PermissionProducts } from "../../enums/permissionProducts";

type Props = SelectProps & {
  availableProducts?: Set<PermissionProducts>;
};

const SelectProduct = ({ availableProducts, ...props }: Props) => {
  const { formatMessage } = useIntl();

  const options = useMemo(() => {
    const allOptions = [
      { value: PermissionProducts.Competitions, label: formatMessage({ id: "permissions.user.product.competitions" }) },
      { value: PermissionProducts.TeamManager, label: formatMessage({ id: "permissions.user.product.teamManager" }) },
    ];
    if (!availableProducts) {
      return allOptions;
    }
    return allOptions.filter(({ value }) => availableProducts.has(value));
  }, [availableProducts, formatMessage]);

  return <Select placeholder={formatMessage({ id: "permissions.user.selectProduct" })} options={options} {...props} />;
};

export default SelectProduct;
